export default "__VITE_ASSET__DlXheUHe__"